export const SCRIPT_NODE_TYPE = 'script';
export const TAG_NODE_TYPE = 'tag';
export const SCRIPT_TAG = 'script';
